import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { TransactionModal } from 'src/components/transaction-modal';

interface TransactionDrawerContextValue {
  openTransactionDrawer: (options?: { studentId?: string }) => void;
  closeTransactionDrawer: () => void;
  isOpen: boolean;
}

const TransactionDrawerContext = createContext<TransactionDrawerContextValue | undefined>(undefined);

export const TransactionDrawerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [studentId, setStudentId] = useState<string | undefined>(undefined);

  const openTransactionDrawer = useCallback((options?: { studentId?: string }) => {
    setStudentId(options?.studentId);
    setIsOpen(true);
  }, []);

  const closeTransactionDrawer = useCallback(() => {
    setIsOpen(false);
    setStudentId(undefined);
  }, []);

  return (
    <TransactionDrawerContext.Provider
      value={{
        openTransactionDrawer,
        closeTransactionDrawer,
        isOpen,
      }}
    >
      {children}
      <TransactionModal
        open={isOpen}
        closeModal={closeTransactionDrawer}
        studentId={studentId}
      />
    </TransactionDrawerContext.Provider>
  );
};

export const useTransactionDrawer = (): TransactionDrawerContextValue => {
  const context = useContext(TransactionDrawerContext);
  if (!context) {
    throw new Error('useTransactionDrawer must be used within a TransactionDrawerProvider');
  }
  return context;
};
